<template>
  <div class="jobInformation">
    <div class="recruit-content-top">
      <div class="left">
        <div class="left-name">
          <span v-if="$t('contactUs.job2.urgent')">{{ $t('contactUs.urgent') }}</span>
          <p>{{ $t('contactUs.job2.name') }}</p>
        </div>
        <div class="left-info">
          <span v-for="(tag, i) in $t('contactUs.job2.tags')" :key="i">{{ tag }}</span>
        </div>
      </div>
      <div class="right">{{ $t('contactUs.job2.date') }}</div>
    </div>

    <div class="recruit-content-info">
      <div class="info-item" v-for="(section, si) in $t('contactUs.job2.sections')" :key="si">
        <div class="info-item-title">{{ section.title }}</div>
        <div class="info-item-content">
          <!-- 普通列表条目 -->
          <template v-if="section.items">
            <div class="item">
              <p v-for="(item, ii) in section.items" :key="ii">{{ item }}</p>
            </div>
          </template>
          <!-- 分组（label + lines）条目 -->
          <template v-if="section.groups">
            <div class="item" v-for="(group, gi) in section.groups" :key="gi">
              <span>{{ group.label }}</span>
              <p v-for="(line, li) in group.lines" :key="li">{{ line }}</p>
            </div>
          </template>
        </div>
      </div>

      <div class="info-item">
        <div class="info-item-title">{{ $t('contactUs.job2.resume') }}</div>
        <div class="info-item-content">{{ $t('contactUs.job2.resumeContent') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.jobInformation {
  .recruit-content-top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 40px;
    border-bottom: 1px solid rgba(43, 50, 71, 0.1);
    .left {
      .left-name {
        display: flex;
        align-items: center;
        span {
          padding: 4px 7px;
          color: rgb(225, 0, 15);
          background-color: rgba(223, 0, 15, 0.1);
          border-radius: 4px;
          margin-right: 6px;
        }
        p {
          font-weight: 600;
          font-size: 24px;
          line-height: 34px;
        }
      }
      .left-info {
        padding-top: 16px;
        span {
          margin-right: 24px;
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;
          color: rgba(43, 50, 71, 0.7);
        }
      }
    }
    .right {
      font-weight: 400;
      font-size: 18px;
      line-height: 20px;
      color: rgba(43, 50, 71, 0.4);
    }
  }
  .recruit-content-info {
    padding-top: 40px;
    .info-item {
      padding-bottom: 40px;
      &:last-child {
        padding-bottom: 0;
      }
      .info-item-title {
        font-weight: 700;
        font-size: 18px;
        line-height: 32px;
        color: rgb(43, 50, 71);
        padding-bottom: 10px;
      }
      .info-item-content {
        font-weight: 400;
        font-size: 18px;
        line-height: 32px;
        color: rgba(43, 50, 71, 0.7);
        .item {
          padding-bottom: 16px;
          &:last-child {
            padding-bottom: 0;
          }
          span {
            font-weight: 600;
            display: block;
            margin-bottom: 4px;
          }
        }
      }
    }
  }
}
</style>
